import { apiJson } from '../api';
import { getAccessToken } from '../auth';

export interface BetaSearch {
  id: string;
  name: string;
  description: string;
  revision: number;
  is_public: boolean;
  is_owner?: boolean;
  slug?: string;
  dismissed?: boolean;
  legacy_ids?: string[];
  included: boolean;
}
const base = '/api/v1/reader/searches';
export function listBetaSearches(): Promise<{ searches: BetaSearch[]; public_searches: BetaSearch[] }> {
  return apiJson('/api/v1/feeds', { public: !getAccessToken() });
}
export function saveBetaSearch(description: string, publicId?: string, showInHome = true): Promise<BetaSearch> {
  return apiJson(base, { method: 'POST', json: { description, public_id: publicId, show_in_home: showInHome } });
}
export function setSearchIncluded(id: string, included: boolean): Promise<void> {
  return apiJson(`${base}/${id}/inclusion`, { method: 'PATCH', json: { included } });
}
export function deleteBetaSearch(id: string): Promise<void> {
  return apiJson(`${base}/${id}`, { method: 'DELETE', json: { confirm: true } });
}
export function editBetaSearch(
  id: string,
  updates: { name?: string; description?: string; revision?: number },
): Promise<BetaSearch> {
  return apiJson(`${base}/${id}`, { method: 'PATCH', json: updates });
}
export function editPublicSearch(id: string, description: string, revision: number, name?: string): Promise<BetaSearch> {
  return editBetaSearch(id, { description, revision, name });
}

export function getSharedSearch(id: string): Promise<BetaSearch> {
  return apiJson(`${base}/${encodeURIComponent(id)}`, { public: !getAccessToken() });
}
export function subscribeSharedSearch(id: string): Promise<BetaSearch> {
  return apiJson(`${base}/${encodeURIComponent(id)}/subscription`, { method: 'POST' });
}

export function restoreBetaSearch(id: string, included: boolean): Promise<BetaSearch> {
  return apiJson(`${base}/${id}/restore`, { method: 'POST', json: { included } });
}
